import React from 'react';
import { Box, } from '@mui/material';
import { formatDateLong } from '../../../services/apiServices';




const PackingListPrintFirst = ({ invNo, invoiceData, salesContracts, shippingmark, coaRecords, companyBanks, shippingBooking, shipments, paymentVoucher, companyTaxes, termConditions, footer }) => {
    //   order detail  
    const companyFooter = shipments?.company?.companyFooter || '';
    const companyLogo = shipments?.company?.companyLogo || '';
    const invoiceShippingmark = shippingmark?.shippingMark || '';
    const batchNo = shippingmark?.batchNo || '';
    const salesContractNo = salesContracts?.salesContractNo || '';
    const productName = shippingmark?.productsList?.productName || '';
    const invoiceDate = formatDateLong(invoiceData?.date || "");
    const mfgDate = formatDateLong(coaRecords?.mfgDate || "");
    const expiryDate = formatDateLong(coaRecords?.expiryDate || "");
    const mark = invoiceData?.mark || '';
    const quantity = invoiceData?.quantity || '';
    const description = invoiceData?.description || '';
    const pkg = invoiceData?.pkg || '';
    const nw = invoiceData?.nw || '';
    const tw = invoiceData?.tw || '';
    const measurement = invoiceData?.measurement || '';
    const totalPackedIn = invoiceData?.totalPackedIn || '';
    const totalGrossWeight = invoiceData?.totalGrossWeight || '';
    const totalNetWeight = invoiceData?.totalNetWeight || '';
    const casNo = invoiceData?.casNo || '';
    const iupac = invoiceData?.iupac || '';
    // Bank info
    const bankName = companyBanks?.bankName || '';
    const accountNumber = companyBanks?.accountNumber || '';
    const accountHolderName = companyBanks?.accountHolderName || '';
    const swiftCode = companyBanks?.swiftCode || '';
    const bankAddress = companyBanks?.bankAddress || '';
    const countryName = companyBanks?.country?.name || '';
    // ligal info
    const panNumber = companyTaxes?.panNumber || '';
    const iecNumber = companyTaxes?.iecNumber || '';
    const gstNumber = companyTaxes?.gstNumber || '';
    // shipments info
    const expectedEtd = shipments?.expectedEtd || '';
    const noOfContainers = shipments?.noOfContainers || '';
    const note = shipments?.note || '';
    const createdAt = shipments?.createdAt || '';
    // User info
    const userFirstName = shipments?.user?.firstName || '';
    const userLastName = shipments?.user?.lastName || '';
    const userFullName = `${userFirstName} ${userLastName}`.trim();
    // Company info
    const companyName = shipments?.company?.companyName || '';
    const companyMobile = shipments?.company?.mobile || '';
    const companyEmail = shipments?.company?.email || '';
    const companyAddress = shipments?.company?.address || '';
    const companyPincode = shipments?.company?.pincode || '';
    const companyWebsite = shipments?.company?.website || '';
    const companyTelephone = shipments?.company?.telephone || '';
    const baseCurrencyName = shipments?.company?.baseCurrencyData?.currency_name || '';
    const baseCurrencySymbol = shipments?.company?.baseCurrencyData?.currency_symbol || '';
    const companyCountry = shipments?.company?.country?.name || '';
    const companyState = shipments?.company?.state?.name || '';
    const companyCity = shipments?.company?.city?.name || '';
    const Signature = shipments?.company?.companySignStamp || '';

    const cifFobName = shipments?.cifFob?.cifFobName || '';
    const paymentMethodName = shipments?.paymentMethod?.paymentMethodName || '';
    const shipmentTypeName = shipments?.shipmentType?.shipmentTypeName || '';
    const currencyName = shipments?.currency?.currency_name || '';
    const currencySymbol = shipments?.currency?.currency_symbol || '';
    // Customer
    const customerName = shipments?.customer?.clientCompanyName || '';
    const customerMobile = shipments?.customer?.mobile || '';
    const customerEmail = shipments?.customer?.email || '';
    const billingStreet = shipments?.customer?.billingStreet || '';
    const billingPincode = shipments?.customer?.billingPincode || '';
    const billingCountry = shipments?.customer?.billingCountry?.name || '';
    const billingState = shipments?.customer?.billingState?.name || '';
    const billingCity = shipments?.customer?.billingCity?.name || '';
    //booking
    const portOfLoading = `${invoiceData?.loading?.portName || ""}, ${invoiceData?.loading?.country?.name || ""}`.trim();
    const portOfDestination = `${invoiceData?.destination?.portName || ""}, ${invoiceData?.destination?.country?.name || ""}`.trim();

    return (
        <>
            <div style={{
                fontSize: "12px",
                textTransform: "capitalize",
                lineHeight: "150%",
                opacity: 1,
                WebkitFontSmoothing: 'antialiased',
                MozOsxFontSmoothing: 'grayscale',
            }}>
                <div
                    style={{
                        display: footer ? 'flex' : 'none',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-start',
                        width: '100%',
                    }}
                >
                    <Box
                        component="img"
                        src={companyLogo}
                        style={{
                            maxWidth: '100px',
                            width: '100%',
                            height: 'auto',
                            objectFit: 'cover',
                        }}
                    />
                </div>
                <div style={{ position: 'relative', padding: '0px', marginTop: footer ? '0px' : '50px', }}>


                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlign: 'center',
                            margin: '20px',
                        }}
                    >
                        <p style={{ fontWeight: 'bold', fontSize: '14px', margin: 0, textTransform: 'uppercase' }}>
                            Packing List
                        </p>
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            width: '100%',
                            justifyContent: 'space-between',

                        }}
                    >
                        <div
                            style={{
                                flex: '0 0 70%',
                                display: 'flex',
                                gap: '8px',
                                alignItems: 'flex-start',
                            }}
                        >
                            <div>Marks:</div>
                            <div>
                                <span>{mark}</span>,<br />
                                <span>Net weight:</span> <span>{nw}</span><br />
                                <span>Gross weight:</span> <span>{tw}</span><br />
                                <span>Batch no.:</span> <span>{batchNo}</span><br />
                            </div>
                        </div>
                        <div
                            style={{
                                flex: '0 0 30%',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                gap: '4px',
                                textAlign: 'left',
                            }}
                        >
                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                <div>Invoice No:</div>
                                <div>{invNo}</div>
                            </div>
                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                <div>Date:</div>
                                <div>{invoiceDate}</div>
                            </div>
                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                <div>SC no.:</div>
                                <div>{salesContractNo}</div>
                            </div>
                        </div>
                    </div>

                </div>
                <br />
                <table
                    cellPadding="8"
                    cellSpacing="0"
                    style={{ width: '100%', border: 'none', fontSize: "12px", borderCollapse: 'collapse', }}
                >
                    <thead  >
                        <tr style={{ backgroundColor: "#ededed" }}>
                            <th style={{
                                textAlign: 'center', width: "10%", borderTop: '1px solid #5A5A5A', borderBottom: '1px solid #5A5A5A', borderLeft: 'none', borderRight: 'none',
                            }}>Case No.</th>
                            <th style={{ textAlign: 'center', width: "10%", borderTop: '1px solid #5A5A5A', borderBottom: '1px solid #5A5A5A', borderLeft: 'none', borderRight: 'none', }}>packages</th>
                            <th style={{ textAlign: 'center', width: "40%", borderTop: '1px solid #5A5A5A', borderBottom: '1px solid #5A5A5A', borderLeft: 'none', borderRight: 'none', }}>Description and Specification</th>
                            <th style={{ textAlign: 'center', width: "10%", borderTop: '1px solid #5A5A5A', borderBottom: '1px solid #5A5A5A', borderLeft: 'none', borderRight: 'none', }}>Quantity</th>
                            <th style={{ textAlign: 'center', width: "10%", borderTop: '1px solid #5A5A5A', borderBottom: '1px solid #5A5A5A', borderLeft: 'none', borderRight: 'none', }}>N.W.</th>
                            <th style={{ textAlign: 'center', width: "10%", borderTop: '1px solid #5A5A5A', borderBottom: '1px solid #5A5A5A', borderLeft: 'none', borderRight: 'none', }}>G.W.</th>
                            <th style={{ textAlign: 'center', width: "10%", borderTop: '1px solid #5A5A5A', borderBottom: '1px solid #5A5A5A', borderLeft: 'none', borderRight: 'none', }}>Meas</th>
                        </tr>
                    </thead>
                    <tbody style={{ textTransform: "uppercase", }}>
                        <tr style={{ textTransform: "uppercase", height: "150px" }}  >
                            <td style={{ textAlign: 'center', verticalAlign: 'top', border: 'none', }}> 01 </td>
                            <td style={{ textAlign: 'center', verticalAlign: 'top', border: 'none', }}>{pkg}</td>
                            <td style={{ textAlign: 'center', verticalAlign: 'top', border: 'none', }}>{description}</td>
                            <td style={{ textAlign: 'center', verticalAlign: 'top', border: 'none', }}>{quantity}</td>
                            <td style={{ textAlign: 'center', verticalAlign: 'top', border: 'none', }}>{nw}</td>
                            <td style={{ textAlign: 'center', verticalAlign: 'top', border: 'none', }}>{tw}</td>
                            <td style={{ textAlign: 'center', verticalAlign: 'top', border: 'none', }}>{measurement}</td>
                        </tr>
                        <tr>
                            <td style={{ textAlign: 'right', borderTop: '1px solid #5A5A5A', borderLeft: 'none', borderRight: 'none', }} colSpan={2}><span>Total</span></td>
                            <td style={{ textAlign: 'center', borderTop: '1px solid #5A5A5A', borderLeft: 'none', borderRight: 'none', }}>{pkg}</td>
                            <td style={{ textAlign: 'center', borderTop: '1px solid #5A5A5A', borderLeft: 'none', borderRight: 'none', }}>{quantity}</td>
                            <td style={{ textAlign: 'center', borderTop: '1px solid #5A5A5A', borderLeft: 'none', borderRight: 'none', }}>{nw}</td>
                            <td style={{ textAlign: 'center', borderTop: '1px solid #5A5A5A', borderLeft: 'none', borderRight: 'none', }}>{tw}</td>
                            <td style={{ textAlign: 'center', borderTop: '1px solid #5A5A5A', borderLeft: 'none', borderRight: 'none', }}>{measurement}</td>
                        </tr>
                    </tbody>
                </table>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%', paddingTop: "20px" }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                        <div>Total packages : {pkg}</div>
                        <div>Total Gross Weight: {tw}</div>
                        <div>Total Net Weight: {nw}</div>
                        <div>Total Measurement: {measurement}</div>
                    </div>

                    <div style={{ width: '30%', textAlign: 'right', paddingTop: "30px" }}>
                        <p style={{ margin: 1 }}>
                            <strong>For {companyName}</strong>
                        </p>
                        <Box
                            component="img"
                            src={Signature}

                            style={{
                                maxWidth: '100px',
                                width: '100%',
                                height: Signature ? 'auto' : '100px',
                                marginBottom: 1,
                            }}
                        />
                        <p style={{ margin: 1 }}>Authorized Signatory</p>
                    </div>
                </div>
                <div
                    component="footer"
                    style={{
                        display: footer ? 'block' : 'none',
                        width: '100%',
                        textAlign: 'center',
                        marginTop: '10px',
                        boxSizing: 'border-box',
                    }}
                >
                    <Box
                        component="img"
                        src={companyFooter}

                        style={{
                            maxWidth: '100%',
                            height: 'auto',
                            objectFit: 'cover',
                        }}
                    />
                </div>

            </div >
        </>

    );
};
const PackingListPrintSecond = ({ invNo, invoiceData, shippingmark, companyBanks, shippingBooking, shipments, paymentVoucher, companyTaxes, termConditions, footer }) => {
    //   order detail  
    const companyFooter = shipments?.company?.companyFooter || '';
    const companyLogo = shipments?.company?.companyLogo || '';
    const invoiceShippingmark = shippingmark?.shippingMark || '';
    const batchNo = shippingmark?.batchNo || '';
    const productName = shippingmark?.productsList?.productName || '';
    const invoiceDate = formatDateLong(invoiceData?.date || "");
    const mark = invoiceData?.mark || '';
    const quantity = invoiceData?.quantity || '';
    const description = invoiceData?.description || '';
    const pkg = invoiceData?.pkg || '';
    const nw = invoiceData?.nw || '';
    const tw = invoiceData?.tw || '';
    const measurement = invoiceData?.measurement || '';
    const totalPackedIn = invoiceData?.totalPackedIn || '';
    const totalGrossWeight = invoiceData?.totalGrossWeight || '';
    const totalNetWeight = invoiceData?.totalNetWeight || '';
    const casNo = invoiceData?.casNo || '';
    const iupac = invoiceData?.iupac || '';
    // Bank info
    const bankName = companyBanks?.bankName || '';
    const accountNumber = companyBanks?.accountNumber || '';
    const accountHolderName = companyBanks?.accountHolderName || '';
    const swiftCode = companyBanks?.swiftCode || '';
    const bankAddress = companyBanks?.bankAddress || '';
    const countryName = companyBanks?.country?.name || '';
    // ligal info
    const panNumber = companyTaxes?.panNumber || '';
    const iecNumber = companyTaxes?.iecNumber || '';
    const gstNumber = companyTaxes?.gstNumber || '';
    // shipments info
    const expectedEtd = shipments?.expectedEtd || '';
    const noOfContainers = shipments?.noOfContainers || '';
    const note = shipments?.note || '';
    const createdAt = shipments?.createdAt || '';
    // User info
    const userFirstName = shipments?.user?.firstName || '';
    const userLastName = shipments?.user?.lastName || '';
    const userFullName = `${userFirstName} ${userLastName}`.trim();
    // Company info
    const companyName = shipments?.company?.companyName || '';
    const companyMobile = shipments?.company?.mobile || '';
    const companyEmail = shipments?.company?.email || '';
    const companyAddress = shipments?.company?.address || '';
    const companyPincode = shipments?.company?.pincode || '';
    const companyWebsite = shipments?.company?.website || '';
    const companyTelephone = shipments?.company?.telephone || '';
    const baseCurrencyName = shipments?.company?.baseCurrencyData?.currency_name || '';
    const baseCurrencySymbol = shipments?.company?.baseCurrencyData?.currency_symbol || '';
    const companyCountry = shipments?.company?.country?.name || '';
    const companyState = shipments?.company?.state?.name || '';
    const companyCity = shipments?.company?.city?.name || '';
    const Signature = shipments?.company?.companySignStamp || '';

    const cifFobName = shipments?.cifFob?.cifFobName || '';
    const paymentMethodName = shipments?.paymentMethod?.paymentMethodName || '';
    const shipmentTypeName = shipments?.shipmentType?.shipmentTypeName || '';
    const currencyName = shipments?.currency?.currency_name || '';
    const currencySymbol = shipments?.currency?.currency_symbol || '';
    // Customer
    const customerName = shipments?.customer?.clientCompanyName || '';
    const customerMobile = shipments?.customer?.mobile || '';
    const customerEmail = shipments?.customer?.email || '';
    const billingStreet = shipments?.customer?.billingStreet || '';
    const billingPincode = shipments?.customer?.billingPincode || '';
    const billingCountry = shipments?.customer?.billingCountry?.name || '';
    const billingState = shipments?.customer?.billingState?.name || '';
    const billingCity = shipments?.customer?.billingCity?.name || '';
    //booking
    const portOfLoading = `${invoiceData?.loading?.portName || ""}, ${invoiceData?.loading?.country?.name || ""}`.trim();
    const portOfDestination = `${invoiceData?.destination?.portName || ""}, ${invoiceData?.destination?.country?.name || ""}`.trim();

    return (
        <>
            <div style={{
                fontSize: "12px",
                textTransform: "capitalize",
                lineHeight: "150%",
                opacity: 1,
                WebkitFontSmoothing: 'antialiased',
                MozOsxFontSmoothing: 'grayscale',
            }}>
                <div
                    style={{
                        display: footer ? 'flex' : 'none',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-start',
                        width: '100%',
                    }}
                >
                    <Box
                        component="img"
                        src={companyLogo}
                        style={{
                            maxWidth: '100px',
                            width: '100%',
                            height: 'auto',
                            objectFit: 'cover',
                        }}
                    />
                </div>
                <div style={{ position: 'relative', padding: '0px', marginTop: footer ? '0px' : '50px', }}>


                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlign: 'center',
                            margin: '20px',
                        }}
                    >
                        <p style={{ fontWeight: 'bold', fontSize: '14px', margin: 0, textTransform: 'uppercase' }}>
                            Packing List
                        </p>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                            width: '100%',
                        }}
                    >
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                            <div  >Contract No.: {customerMobile}</div>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                gap: '4px',
                                textAlign: 'left',
                            }}
                        >
                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center', }}>
                                <div  >Date:</div>
                                <div> {invoiceDate}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <table
                    border='1px solid #5A5A5A'
                    cellPadding="8"
                    cellSpacing="0"
                    style={{ width: '100%', fontSize: "12px", borderCollapse: 'collapse', border: '1px solid #5A5A5A' }}
                >
                    <thead  >
                        <tr  >
                            <th style={{ textAlign: 'left', verticalAlign: "top", width: "30%", fontWeight: "400" }}>Shipping Mark:
                                <br />
                                {batchNo}

                            </th>
                            <th style={{ textAlign: 'left', verticalAlign: "top", width: "70%", fontWeight: "400" }}>Consignee: <strong>{customerName}</strong>
                                <div  >
                                    <p style={{ margin: 1 }}>
                                        <span>
                                            add: {billingStreet && `${billingStreet},`}
                                            <br />
                                            {[billingCity, billingState, billingCountry].filter(Boolean).join(', ')}
                                            {billingPincode && ` - ${billingPincode}`}
                                        </span>
                                    </p>
                                    <p style={{ margin: 1 }}>
                                        <span >Email:</span> <span>{customerEmail}</span>
                                    </p>
                                    <p style={{ margin: 1 }}>
                                        <span >Mobile:</span> <span>{customerMobile}</span>
                                    </p>
                                    <p style={{ margin: 1 }}>
                                        <span >IEC no:</span> <span>{iecNumber}</span>
                                    </p>
                                    <p style={{ margin: 1 }}>
                                        <span >GST no:</span> <span>{gstNumber}</span>
                                    </p>
                                    <p style={{ margin: 1 }}>
                                        <span >PAN no:</span> <span>{panNumber}</span>
                                    </p>

                                </div>

                            </th>
                        </tr>
                    </thead>
                </table>
                <br />
                <table
                    border='1px solid #5A5A5A'
                    cellPadding="8"
                    cellSpacing="0"
                    style={{ width: '100%', fontSize: "12px", borderCollapse: 'collapse', border: '1px solid #5A5A5A' }}
                >
                    <thead  >
                        <tr style={{ backgroundColor: "#ededed" }}>
                            <th style={{ textAlign: 'center', width: "30%" }}>Product Name & package</th>
                            <th style={{ textAlign: 'center', width: "20%" }}>Quantity</th>
                            <th style={{ textAlign: 'center', width: "16%" }}>N.W.</th>
                            <th style={{ textAlign: 'center', width: "16%" }}>G.W.</th>
                            <th style={{ textAlign: 'center', width: "16%" }}>Volume</th>
                        </tr>
                    </thead>
                    <tbody style={{ textTransform: "uppercase", }}>
                        <tr style={{ textTransform: "uppercase", height: "300px" }}  >
                            <td style={{ textAlign: 'center', verticalAlign: "top" }}>
                                {productName}
                                <br />
                                <br />
                                <br />
                                <br />
                                <br />

                                {pkg}
                            </td>
                            <td style={{ textAlign: 'center', verticalAlign: "top" }}>{quantity}</td>
                            <td style={{ textAlign: 'center', verticalAlign: "top" }}>{nw}</td>
                            <td style={{ textAlign: 'center', verticalAlign: "top" }}>{tw}</td>
                            <td style={{ textAlign: 'center', verticalAlign: "top" }}>{measurement}</td>
                        </tr>
                    </tbody>
                </table>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%', paddingTop: "20px" }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                    </div>

                    <div style={{ width: '30%', textAlign: 'right', paddingTop: "30px" }}>
                        <p style={{ margin: 1 }}>
                            <strong>For {companyName}</strong>
                        </p>
                        <Box
                            component="img"
                            src={Signature}

                            style={{
                                maxWidth: '100px',
                                width: '100%',
                                height: Signature ? 'auto' : '100px',
                                marginBottom: 1,
                            }}
                        />
                        <p style={{ margin: 1 }}>Authorized Signatory</p>
                    </div>
                </div>
                <div
                    component="footer"
                    style={{
                        display: footer ? 'block' : 'none',
                        width: '100%',
                        textAlign: 'center',
                        marginTop: '10px',
                        boxSizing: 'border-box',
                    }}
                >
                    <Box
                        component="img"
                        src={companyFooter}

                        style={{
                            maxWidth: '100%',
                            height: 'auto',
                            objectFit: 'cover',
                        }}
                    />
                </div>

            </div >
        </>

    );
};


const PackingListPrintFour = ({ invNo, invoiceData, shippingmark, companyBanks, shippingBooking, shipments, paymentVoucher, companyTaxes, termConditions, footer }) => {
    //   order detail  
    const companyFooter = shipments?.company?.companyFooter || '';
    const companyLogo = shipments?.company?.companyLogo || '';
    const invoiceShippingmark = shippingmark?.shippingMark || '';
    const batchNo = shippingmark?.batchNo || '';
    const productName = shippingmark?.productsList?.productName || '';
    const invoiceDate = formatDateLong(invoiceData?.date || "");
    const mark = invoiceData?.mark || '';
    const quantity = invoiceData?.quantity || '';
    const description = invoiceData?.description || '';
    const pkg = invoiceData?.pkg || '';
    const nw = invoiceData?.nw || '';
    const tw = invoiceData?.tw || '';
    const measurement = invoiceData?.measurement || '';
    const totalPackedIn = invoiceData?.totalPackedIn || '';
    const totalGrossWeight = invoiceData?.totalGrossWeight || '';
    const totalNetWeight = invoiceData?.totalNetWeight || '';
    const casNo = invoiceData?.casNo || '';
    const iupac = invoiceData?.iupac || '';
    // Bank info
    const bankName = companyBanks?.bankName || '';
    const accountNumber = companyBanks?.accountNumber || '';
    const accountHolderName = companyBanks?.accountHolderName || '';
    const swiftCode = companyBanks?.swiftCode || '';
    const bankAddress = companyBanks?.bankAddress || '';
    const countryName = companyBanks?.country?.name || '';
    // ligal info
    const panNumber = companyTaxes?.panNumber || '';
    const iecNumber = companyTaxes?.iecNumber || '';
    const gstNumber = companyTaxes?.gstNumber || '';
    // shipments info
    const expectedEtd = shipments?.expectedEtd || '';
    const noOfContainers = shipments?.noOfContainers || '';
    const note = shipments?.note || '';
    const createdAt = shipments?.createdAt || '';
    // User info
    const userFirstName = shipments?.user?.firstName || '';
    const userLastName = shipments?.user?.lastName || '';
    const userFullName = `${userFirstName} ${userLastName}`.trim();
    // Company info
    const companyName = shipments?.company?.companyName || '';
    const companyMobile = shipments?.company?.mobile || '';
    const companyEmail = shipments?.company?.email || '';
    const companyAddress = shipments?.company?.address || '';
    const companyPincode = shipments?.company?.pincode || '';
    const companyWebsite = shipments?.company?.website || '';
    const companyTelephone = shipments?.company?.telephone || '';
    const baseCurrencyName = shipments?.company?.baseCurrencyData?.currency_name || '';
    const baseCurrencySymbol = shipments?.company?.baseCurrencyData?.currency_symbol || '';
    const companyCountry = shipments?.company?.country?.name || '';
    const companyState = shipments?.company?.state?.name || '';
    const companyCity = shipments?.company?.city?.name || '';
    const Signature = shipments?.company?.companySignStamp || '';

    const cifFobName = shipments?.cifFob?.cifFobName || '';
    const paymentMethodName = shipments?.paymentMethod?.paymentMethodName || '';
    const shipmentTypeName = shipments?.shipmentType?.shipmentTypeName || '';
    const currencyName = shipments?.currency?.currency_name || '';
    const currencySymbol = shipments?.currency?.currency_symbol || '';
    // Customer
    const customerName = shipments?.customer?.clientCompanyName || '';
    const customerMobile = shipments?.customer?.mobile || '';
    const customerEmail = shipments?.customer?.email || '';
    const billingStreet = shipments?.customer?.billingStreet || '';
    const billingPincode = shipments?.customer?.billingPincode || '';
    const billingCountry = shipments?.customer?.billingCountry?.name || '';
    const billingState = shipments?.customer?.billingState?.name || '';
    const billingCity = shipments?.customer?.billingCity?.name || '';
    //booking
    const portOfLoading = `${invoiceData?.loading?.portName || ""}, ${invoiceData?.loading?.country?.name || ""}`.trim();
    const portOfDestination = `${invoiceData?.destination?.portName || ""}, ${invoiceData?.destination?.country?.name || ""}`.trim();

    return (
        <>
            <div style={{
                fontSize: "12px",
                textTransform: "capitalize",
                lineHeight: "150%",
                opacity: 1,
                WebkitFontSmoothing: 'antialiased',
                MozOsxFontSmoothing: 'grayscale',
            }}>
                <div
                    style={{
                        display: footer ? 'flex' : 'none',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-start',
                        width: '100%',
                    }}
                >
                    <Box
                        component="img"
                        src={companyLogo}
                        style={{
                            maxWidth: '100px',
                            width: '100%',
                            height: 'auto',
                            objectFit: 'cover',
                        }}
                    />
                </div>
                <div style={{ position: 'relative', padding: '0px', marginTop: footer ? '0px' : '50px', }}>


                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlign: 'center',
                            margin: '20px',
                        }}
                    >
                        <p style={{ fontWeight: 'bold', fontSize: '14px', margin: 0, textTransform: 'uppercase' }}>
                            Packing List
                        </p>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                            width: '100%',
                        }}
                    >
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                            <div  >To:</div>
                            <div>
                                <strong>{customerName}</strong> ,<br />
                                <span>
                                    {billingStreet && `${billingStreet},`}
                                    <br />
                                    {[billingCity, billingState, billingCountry].filter(Boolean).join(', ')}
                                    {billingPincode && ` - ${billingPincode}`}
                                </span> <br />
                                <span >Email:</span> <span>{customerEmail}</span><br />
                                <span >Mobile:</span> <span>{customerMobile}</span><br />
                                <span >IEC no:</span> <span>{iecNumber}</span><br />
                                <span >GST no:</span> <span>{gstNumber}</span><br />
                                <span >PAN no:</span> <span>{panNumber}</span>
                            </div>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                gap: '4px',
                                textAlign: 'left',
                            }}
                        >
                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center', }}>
                                <div  >Invoice No:</div>
                                <div>{invNo}</div>
                            </div>
                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center', }}>
                                <div  >Date:</div>
                                <div> {invoiceDate}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: '16px',
                        marginTop: '20px',
                        flexWrap: 'wrap',
                    }}
                >
                    <div style={{ flex: '1' }}>
                        <span  >Port of Loading:</span>
                        <span> {portOfLoading}</span>
                    </div>
                    <div style={{ flex: '1' }}>
                        <span  >Port of Destination:</span>
                        <span> {portOfDestination}</span>
                    </div>
                    <div style={{ flex: '1' }}>
                        <span  >Route:</span>
                        <span> {shipmentTypeName}</span>
                    </div>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '3px', width: '100%', }}>
                    <div style={{ height: '1px', backgroundColor: 'black', width: '100%' }} />
                    <div style={{ height: '1px', backgroundColor: 'black', width: '100%' }} />
                </div>
                <br />
                <table
                    border='1px solid #5A5A5A'
                    cellPadding="8"
                    cellSpacing="0"
                    style={{ width: '100%', fontSize: "12px", borderCollapse: 'collapse', border: '1px solid #5A5A5A' }}
                >
                    <thead  >
                        <tr style={{ backgroundColor: "#ededed" }}>
                            <th style={{ textAlign: 'center', width: "10%" }}>Mark</th>
                            <th style={{ textAlign: 'center', width: "40%" }}>Description</th>
                            <th style={{ textAlign: 'center', width: "10%" }}>PKG</th>
                            <th style={{ textAlign: 'center', width: "10%" }}>Quantity</th>
                            <th style={{ textAlign: 'center', width: "10%" }}>N.W.</th>
                            <th style={{ textAlign: 'center', width: "10%" }}>G.W.</th>
                            <th style={{ textAlign: 'center', width: "10%" }}>Meas</th>
                        </tr>
                    </thead>
                    <tbody style={{ textTransform: "uppercase", }}>
                        <tr style={{ textTransform: "uppercase", height: "300px" }}  >
                            <td style={{ textAlign: 'center' }}>{mark}</td>
                            <td style={{ textAlign: 'center' }}>{description}</td>
                            <td style={{ textAlign: 'center' }}>{pkg}</td>
                            <td style={{ textAlign: 'center' }}>{quantity}</td>
                            <td style={{ textAlign: 'center' }}>{nw}</td>
                            <td style={{ textAlign: 'center' }}>{tw}</td>
                            <td style={{ textAlign: 'center' }}>{measurement}</td>
                        </tr>
                        <tr>
                            <td style={{ textAlign: 'right', }} colSpan={2}><span>Total</span></td>
                            <td style={{ textAlign: 'center' }}>{pkg}</td>
                            <td style={{ textAlign: 'center' }}>{quantity}</td>
                            <td style={{ textAlign: 'center' }}>{nw}</td>
                            <td style={{ textAlign: 'center' }}>{tw}</td>
                            <td style={{ textAlign: 'center' }}>{measurement}</td>
                        </tr>
                    </tbody>
                </table>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%', paddingTop: "20px" }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                        <div>Total Packed In {pkg}</div>
                        <div>Total Gross Weight {tw}</div>
                        <div>Total Net Weight {nw}</div>
                        <div>Total Measurement {measurement}</div>
                    </div>

                    <div style={{ width: '30%', textAlign: 'right', paddingTop: "30px" }}>
                        <p style={{ margin: 1 }}>
                            <strong>For {companyName}</strong>
                        </p>
                        <Box
                            component="img"
                            src={Signature}

                            style={{
                                maxWidth: '100px',
                                width: '100%',
                                height: Signature ? 'auto' : '100px',
                                marginBottom: 1,
                            }}
                        />
                        <p style={{ margin: 1 }}>Authorized Signatory</p>
                    </div>
                </div>
                <div
                    component="footer"
                    style={{
                        display: footer ? 'block' : 'none',
                        width: '100%',
                        textAlign: 'center',
                        marginTop: '10px',
                        boxSizing: 'border-box',
                    }}
                >
                    <Box
                        component="img"
                        src={companyFooter}

                        style={{
                            maxWidth: '100%',
                            height: 'auto',
                            objectFit: 'cover',
                        }}
                    />
                </div>
            </div >
        </>

    );
};

export {
    PackingListPrintFirst,
    PackingListPrintSecond,
    PackingListPrintFour
};
